<div class="success-verification-wrapper">
    <div class="anvt-container">
        <div class="anvt-header">
            <img src="https://togoanvt.org/wp-content/uploads/2020/11/logo_retina.png" alt="ANVT Logo" class="anvt-logo">
        </div>

        <div class="anvt-content">
            <div class="success-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="#28a745">
                    <path d="M12 0a12 12 0 1012 12A12 12 0 0012 0zm6.927 8.2l-6.845 9.289a1 1 0 01-1.61.094l-3.96-5.6a1 1 0 111.627-1.163l3.21 4.552 6.227-8.451a1 1 0 111.538 1.279z"/>
                </svg>
            </div>

            <h2 class="anvt-title">Création de compte réussie !</h2>

            <div class="anvt-message">
                <p>Bonjour,</p>
                <p>Félicitations ! Votre compte a été créé avec succès.</p>
                <p>Un courriel de vérification a été envoyé à :</p>
                <p class="email-display">{{ email }}</p>
                <p>Veuillez cliquer sur le lien de vérification pour activer votre compte.</p>
            </div>

            <button routerLink="/login" class="anvt-button">
                Se connecter
            </button>
        </div>

        <div class="anvt-footer">
            <p>ANVT - Agence Nationale du Volontariat au Togo</p>
            <p>Boulevard Eyadéma, Lomé - Togo</p>
        </div>
    </div>
</div>